module.exports = __webpack_public_path__ + "bbf945db61f848603739bcd559ec914d.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/LA.svg
// module id = TLlV
// module chunks = 0